import React, {useState} from 'react';
import {Button} from "antd";
import {DownloadOutlined} from "@ant-design/icons";
import {useSelector} from "react-redux";
import IntlMessage from "../../../../components/IntlMessage/IntlMessage";
import ExportPeopleModal from "../Groups/List/ExportPeopleModal";

// Выгрузка списка студентов и преподавателей одной группы прямо со страницы журнала.
// Кнопка только для админа: /api/admin/** преподавателю недоступен, у него запрос упадёт с 403.
const GroupExportButton = ({groupId, groupTitle}) => {
    const {user} = useSelector(state => state.user);
    const isAdmin = user?.role?.roleName === 'admin';

    const [open, setOpen] = useState(false);

    if (!isAdmin || !groupId) {
        return null;
    }

    return (
        <>
            <Button icon={<DownloadOutlined/>} onClick={() => setOpen(true)}>
                <span><IntlMessage id={'groups.exportList'}/></span>
            </Button>

            <ExportPeopleModal
                open={open}
                onClose={() => setOpen(false)}
                defaultRoles={['STUDENTS', 'TEACHERS']}
                groupId={groupId}
                groupTitle={groupTitle}
            />
        </>
    );
};

export default GroupExportButton;
